import { render, staticRenderFns } from "./PRCTModal.vue?vue&type=template&id=327eee10&scoped=true"
import script from "./PRCTModal.vue?vue&type=script&lang=js"
export * from "./PRCTModal.vue?vue&type=script&lang=js"
import style0 from "./PRCTModal.vue?vue&type=style&index=0&id=327eee10&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327eee10",
  null
  
)

export default component.exports